import Keycloak from 'keycloak-js';
import { KEYCLOAK_MIN_VALIDITY, keycloakConfig, keycloakOptions } from './keycloakConfig';
import { OpenAPI } from '../generatedApi';

export const keycloak = new Keycloak(keycloakConfig);

export const keycloakInit = async () => {
  OpenAPI.TOKEN = async () => {
    await keycloak.updateToken(KEYCLOAK_MIN_VALIDITY);
    return keycloak.token;
  };
  await keycloak.init(keycloakOptions);
  return keycloak;
};
